module.exports = __webpack_public_path__ + "static/media/Delete.9a2dfdff.svg";